var render = function render(){var _vm=this,_c=_vm._self._c;return _c('horizontal-stepper',{attrs:{"app-name":_vm.appName,"steps":_vm.steps,"active-step":_vm.activeStep,"before-completed":_vm.beforeCompleted,"data":_vm.data,"translations":JSON.parse(_vm.translations),"breadcrumbs":JSON.parse(_vm.breadcrumbs),"lang":_vm.lang,"isAndroid":parseInt(_vm.isAndroid),"isDesktop":parseInt(_vm.isDesktop)}})
}
var staticRenderFns = []

export { render, staticRenderFns }